module.exports = __webpack_public_path__ + "img/grants.7a79b052.jpg";